import React from 'react';
import { RegisterForm } from '../components/auth/RegisterForm';

const RegisterPage = () => {
  return <RegisterForm />;
};

export default RegisterPage;
